import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Moon, Sun } from 'lucide-react';
import { appliquerMode, modeChoisi } from './nuit28';
import { getApiUrl } from '../../utils/api';

// LOT 31.1 · un seul interrupteur jour / nuit (Accueil, bandeau du haut, à gauche des crédits) · choix enregistré sur le profil
const lire = () => (document.documentElement.classList.contains('jour') ? 'jour' : 'nuit');
export const useMode = () => {
  const [m, setM] = useState(lire);
  useEffect(() => { const f = (e) => setM(e.detail); window.addEventListener('mode360', f); return () => window.removeEventListener('mode360', f); }, []);
  return m;
};
export const choisirMode = (mode) => { appliquerMode(mode); axios.put(`${getApiUrl()}/me/apparence`, { mode }, { withCredentials: true }).catch(() => {}); };
// le mode suit le compte : relu à l'ouverture de chaque module et quand la page revient au premier plan
const synchro = () => axios.get(`${getApiUrl()}/me/apparence`, { withCredentials: true }).then((r) => { if (r.data?.mode && r.data.mode !== modeChoisi()) appliquerMode(r.data.mode); }).catch(() => {});
export const useChoix = () => { const [c, setC] = useState(modeChoisi); useEffect(() => { const f = () => setC(modeChoisi()); window.addEventListener('mode360', f); return () => window.removeEventListener('mode360', f); }, []); return c; };
export const useSyncMode = () => useEffect(() => {
  synchro(); const f = () => document.visibilityState === 'visible' && synchro();
  document.addEventListener('visibilitychange', f); return () => document.removeEventListener('visibilitychange', f);
}, []);
export const InterrupteurMode = ({ testId = 'mode' }) => {
  const m = useMode();
  return <button type="button" role="switch" aria-checked={m === 'jour'} aria-label={m === 'jour' ? 'Mode jour' : 'Mode nuit'} className="im60" title={m === 'jour' ? 'Passer en mode nuit' : 'Passer en mode jour'} onClick={(e) => { e.stopPropagation(); choisirMode(m === 'jour' ? 'nuit' : 'jour'); }} data-testid={testId}>
    {m === 'jour' ? <Sun size={18} /> : <Moon size={18} />}
  </button>;
};
